

jQuery(document).ready(function($){

	// Move to smaller masthead when scrolling away from top
	$(window).scroll(function(){ 
		if($(window).scrollTop() > 100) {
			$('#masthead').addClass('nav-small');
			$('#masthead').removeClass('header-search-open');
			$('#desktop-search-form').removeClass('header-searchform-open');
		}
	else {
			$('#masthead').removeClass('nav-small');
		}
	});

	
	$('.blog-list-wrap .media-cta-card').matchHeight();

	// Setup keyboard nav for top dropdowns
	// Note: this needs to be done after the feature content injection
	var menuKeyboardNav = function() {
		// get all dropdowns from header
		var menuItem = document.querySelectorAll('#menu-top-persistent-menu > .menu-item-has-children, #top-primary-menu > .menu-item-has-children')

		menuItem.forEach(item => {
			var links = item.querySelectorAll('a')
			// show if focused on any link inside this menu-item
			links.forEach(link => {
				link.addEventListener('focus', event => item.classList.add('show'))
				link.addEventListener('blur', event => item.classList.remove('show'))
			})
		})
	}

	//top nav content injection
	if (typeof sl_navContents !== 'undefined') {
		$.each(sl_navContents,function(){
			$(this.targetSelector).html(this.content);
		});
		// setup listeners after content is injected
		menuKeyboardNav()
	}

	// Search Toggles
	$('#desktop-search').click(function() {
		$('#masthead').toggleClass('header-search-open');
		$('#desktop-search-form').toggleClass('header-searchform-open');
	});

	$('#desktop-search-close').click(function(e) {
		e.preventDefault();
		$('.site-header').removeClass('search-open');
		// Go back to tabindex for search button
		$('.js-search-toggle a').focus();
	});

	$('.js-search-toggle').click(function(e) {
		e.preventDefault();
		$('.site-header').toggleClass('search-open');
		$('#desktop-search-form .search-field').focus();
	});

	function toggleSidebar() {
		$('.menu-toggle').toggleClass('active');
		$('.nav-container').toggleClass('move-to-left');
		$('.site').toggleClass('menu-open');
		$('.site-header').toggleClass('move-site-header-left');
		$('body').toggleClass('restrict-overflow');
	}

	$('#main-nav-toggle').on('click tap', function() {
		toggleSidebar();
	});

	$(document).keyup(function(e) {
		if( e.keyCode === 27) {
			toggleSidebar();
		}
	});

	$('.main-navigation .menu-item-has-children').on('click', function (e) {
		if ($(window).width() > 1200) {
			return;
		}
		$(this).children('a').removeAttr('href');
        $('.open-submenu').not(this).removeClass('open-submenu');
		$(this).toggleClass('open-submenu');
	});

	$(window).resize( function() {
		if( $(this).width() > 1200 ) {
			$('.open-submenu').removeClass('open-submenu');
			// setNavWidths();
		} else {
		}
	});

	// Wire up lightcase related links
	//$('a[data-rel^=lightcase]').lightcase();
	
	//$(document).on('click', 'a[data-rel^=lightcase]', lity);
	$('.close-lightbox').on('click',function(){
		$('span.lightcase-icon-close').click();
	});

	// EIC custom lightbox sizing
	//$(document).on('click', '.eic-infographic a[data-rel^=lightcase]', lity);
	$('.eic-infographic a[data-rel^=lightcase]').lightcase({
		forceWidth: '1000',
		forceHeight: '1000'
	});

	// Customers Page Custom Lightbox Styling
	//$(document).on('click', '.customers-sorter a[data-rel^=lightcase]', lity);
	$('.customers-sorter a[data-rel^=lightcase]').lightcase({
		forceWidth: '2000'
	});

	// Smooth Scrolling
	// Select all links with hashes
	$(function() {
		$('a[href*="#"]:not([data-rel^=lightcase])').click(function() {
			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
				if (target.length) {
					var masthead = $('#masthead'),
						adminbar = $('#wpadminbar'),
						offset = 0;
					if ( masthead.length ) {
						offset += masthead.outerHeight();
					} else if ( adminbar.length ) {
						offset += adminbar.outerHeight();
					}
					$('html,body').animate({
						scrollTop: target.offset().top - offset
					}, 1000);
					return false;
				}
			}
		});
	});

	var menu = $('#site-navigation');
	var push = $('.nav-push');
	var headerPush = $('.mobile-header-push');
	$('#menu-toggle').click(function() {
		menu.toggleClass('menu-open');
		push.toggleClass('nav-push-right');
		headerPush.toggleClass('nav-push-right');
	});

	// tab switching
	$('.sl-tabs-nav-item').click(function () {
		var currentTab = $(this).attr('data-tab');

		$('.sl-tabs-nav-item').removeClass('active-sl-tab');
		$(this).addClass('active-sl-tab');

		$('.sl-tab').each(function () {
			$(this).hide();

			if ($(this).attr('data-tab') == currentTab) {
				$(this).fadeIn();
			}
		});
	});

	$('div .media-cta-card .media-cta-card__content').matchHeight();
	// $('.header-nav > li > .sub-menu > li > .sub-menu').matchHeight();
	$('.product-solutions-carousel-match-height .section-content').matchHeight();
	
    

}); // End Doc Ready
